import React, { useState } from 'react'

import {
  GridRowMenu,
  GridRowMenuButton,
} from 'src/components/Reusable/Grid/GridRowMenu'
import { SavedFiltersModal } from './SavedFiltersModal'

type Mode = 'save' | 'load'

export const SavedFiltersMenu = (): JSX.Element => {
  const [mode, setMode] = useState<Mode>('save')
  const [showModal, setShowModal] = useState(false)

  const open = (m: Mode) => {
    setMode(m)
    setShowModal(true)
  }

  return (
    <>
      <GridRowMenu
        id="saved-filters"
        items={[
          {
            key: 'save',
            item: (
              <GridRowMenuButton onClick={() => open('save')}>
                Save filters
              </GridRowMenuButton>
            ),
          },
          {
            key: 'load',
            item: (
              <GridRowMenuButton onClick={() => open('load')}>
                Load filters
              </GridRowMenuButton>
            ),
          },
        ]}
      />
      <SavedFiltersModal
        show={showModal}
        hide={() => setShowModal(false)}
        mode={mode}
      />
    </>
  )
}
